<template>
  <div id="appMarketWhite">
    <DForm :formItems="searchFormItems" :model="queryModule" label-width="5em">
      <template #actions>
        <el-form-item label-width="0">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-search"
            @click="search"
            >查询</el-button
          >
        </el-form-item>
      </template>
    </DForm>
    <DTable
      :data="list"
      :tableItems="tableItems"
      :pageConfig="pageConfig"
      border
      stripe
      @page-current-change="handleCurrentChange"
      @page-size-change="handleSizeChange"
    >
      <template #header>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          v-has="'add'"
          @click="handleOperate('add')"
          >新增</el-button
        >
      </template>
      <template #status="{ row }">
        <span :style="{ color: 'red' }" v-if="row.status === 0">已下线</span>
        <span :style="{ color: '#67C23A' }" v-else-if="row.status === 1"
          >已上线</span
        >
      </template>
      <template #actions="{ row }">
        <div class="table-actions">
          <el-button
            type="text"
            v-has="'edit'"
            style="margin-right: 10px"
            @click="handleOperate('edit', row)"
            >编辑</el-button
          >
          <el-button type="text" v-has="'onOff'" @click="handleClickOnOff(row)">
            <span :class="row.status == 0 ? 'colorGreen' : 'colorRed'">{{
              row.status == 0 ? "上线" : "下线"
            }}</span>
          </el-button>
        </div>
      </template>
    </DTable>
    <!--  新增/编辑 弹框 -->
    <EditorDialog
      :isShow.sync="editorDialogShow"
      :type="operationType"
      :row="detailData"
      @success="getDataList"
    />
  </div>
</template>
<script>
import EditorDialog from "./components/EditorDialog.vue";
import {
  queryAppMarketWhiteList,
  onlineAppMarketWhite,
  offlineAppMarketWhite,
} from "@/api/appMarketWhite";
import { getProJectList } from "@/api/ozBlockConf";

export default {
  name: "appMarketWhite",
  components: {
    EditorDialog,
  },
  computed: {
    searchFormItems() {
      return [
        {
          label: "客户号",
          prop: "customerId",
          type: "Select",
          span: 4,
          props: {
            filterable: true,
            clearable: true,
            options: [
              { label: "ALL", value: "ALL" },
              ...this.filterCustomerList.map((item) => ({
                label: item.cusNo,
                value: item.cusNo,
              })),
            ],
          },
          events: {
            change: this.handleCustomerFilterChange,
          },
        },
        {
          label: "渠道号",
          prop: "channelId",
          type: "Select",
          span: 4,
          props: {
            filterable: true,
            clearable: true,
            disabled: !this.queryModule.customerId,
            options: [
              { label: "ALL", value: "ALL" },
              ...this.filterChannelList.map((item) => ({
                label: item.channelName,
                value: item.channelName,
              })),
            ],
          },
          events: {
            change: this.handleChannelFilterChange,
          },
        },
        {
          label: "项目号",
          prop: "projectId",
          type: "Select",
          span: 4,
          props: {
            filterable: true,
            clearable: true,
            disabled: !this.queryModule.channelId,
            options: [
              { label: "ALL", value: "ALL" },
              ...this.filterProjectList.map((item) => ({
                label: item.projectName,
                value: item.projectName,
              })),
            ],
          },
        },
        {
          label: "应用名称",
          prop: "apkName",
          type: "Input",
          span: 4,
          props: {
            clearable: true,
          },
          events: {
            "keyup.enter": this.search,
          },
        },
        {
          prop: "actions",
          span: 2,
          isSlot: true,
          labelShow: false,
        },
      ];
    },
    tableItems() {
      return [
        { label: "应用名称", prop: "apkName" },
        { label: "应用包名", prop: "packageName" },
        { label: "市场ID", prop: "marketId" },
        { label: "客户号", prop: "customerId" },
        { label: "渠道号", prop: "channelId" },
        { label: "项目号", prop: "projectId" },
        { label: "创建时间", prop: "createTime", width: 160 },
        { label: "修改时间", prop: "modifyTime", width: 160 },
        { label: "状态", prop: "status", isSlot: true, width: 100 },
        { label: "描述", prop: "desc" },
        {
          label: "操作",
          prop: "actions",
          isSlot: true,
          width: 160,
          fixed: "right",
        },
      ];
    },
    pageConfig() {
      return {
        page: this.queryModule.page,
        size: this.queryModule.size,
        total: this.queryModule.total,
      };
    },
  },
  data() {
    return {
      queryModule: {
        apkName: "",
        customerId: "",
        channelId: "",
        projectId: "",
        page: 1,
        size: 10,
        total: 0,
      },
      list: [],
      detailData: {},
      operationType: "",
      editorDialogShow: false,
      filterCustomerList: [],
      filterChannelList: [],
      filterProjectList: [],
    };
  },
  created() {
    this.getDataList();
  },
  methods: {
    search() {
      this.queryModule.page = 1;
      this.queryModule.total = 0;
      this.getDataList();
    },
    handleCurrentChange(page) {
      this.queryModule.page = page;
      this.getDataList();
    },
    handleSizeChange(size) {
      this.queryModule.size = size;
      this.queryModule.page = 1;
      this.getDataList();
    },
    handleOperate(type, row) {
      this.operationType = type;
      if (type === "add") {
        this.detailData = {};
      } else if (type === "edit") {
        this.detailData = { ...row };
      }
      this.editorDialogShow = true;
    },
    handleClickOnOff(row) {
      const desc = `确定${row.status == 0 ? "上线" : "下线"}吗？`;
      this.$confirm(desc, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.handleEnable(row);
        })
        .catch(() => {});
    },
    // 获取列表数据
    async getDataList() {
      queryAppMarketWhiteList({
        ...this.queryModule,
        count: true,
      }).then((res) => {
        if (res && res.code === 0) {
          const { list = [], total = 0 } = res.data || {};
          this.list = list;
          this.queryModule.total = total;
        } else {
          this.list = [];
        }
      });
      if (!this.filterCustomerList.length) {
        this.filterCustomerList = await this.getFilterOptions({ type: 1 });
      }
    },
    async getFilterOptions(params) {
      const res = await getProJectList(
        { page: 1, size: 3000, ...params },
        false,
      );
      if (res && res.code === 0) {
        return res.data.list || [];
      }
      return [];
    },
    async handleCustomerFilterChange(value) {
      this.queryModule.channelId = "";
      this.queryModule.projectId = "";
      this.filterChannelList = [];
      this.filterProjectList = [];
      if (!value) {
        return;
      }
      this.filterChannelList = await this.getFilterOptions({
        cusNo: value,
        type: 2,
      });
    },
    async handleChannelFilterChange(value) {
      this.queryModule.projectId = "";
      this.filterProjectList = [];
      if (!value || !this.queryModule.customerId) {
        return;
      }
      this.filterProjectList = await this.getFilterOptions({
        cusNo: this.queryModule.customerId,
        channelName: value,
        type: 3,
      });
    },
    handleEnable(row) {
      // status===0 已下线 → 上线；status===1 已上线 → 下线
      const goingOnline = row.status === 0;
      const request = goingOnline
        ? onlineAppMarketWhite
        : offlineAppMarketWhite;
      request({ id: row.id }).then((res) => {
        if (res && res.code === 0) {
          this.$message.success(goingOnline ? "上线成功" : "下线成功");
          this.getDataList();
        } else {
          this.$message.error((res && res.msg) || "操作失败");
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
#appMarketWhite {
  .table-actions {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
  }
}
</style>
